import { useEffect, useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { TextureLoader } from "three";
import { OrbitControls } from "@react-three/drei";
import gsap from "gsap";

const Bottle = () => {
  const bottleRef = useRef();
  const texture = new TextureLoader().load("/Bottle.png"); // Image ko public folder me rakhein

  useFrame(() => {
    if (bottleRef.current) {
      bottleRef.current.rotation.y += 0.01; // Auto rotate
    }
  });

  useEffect(() => {
    const handleScroll = () => {
      const rotationY = window.scrollY * 0.005;
      gsap.to(bottleRef.current.rotation, { y: rotationY, duration: 1 });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <mesh ref={bottleRef}>
      <cylinderGeometry args={[0.5, 0.5, 2, 32]} />
      <meshStandardMaterial map={texture} />
    </mesh>
  );
};

const BottleViewer = () => {
  return (
    <Canvas camera={{ position: [0, 0, 3] }}>
      <ambientLight intensity={0.5} />
      <directionalLight position={[2, 2, 2]} intensity={1} />
      <Bottle />
      <OrbitControls />
    </Canvas>
  );
};

export default BottleViewer;




// import React from 'react'
// import './contact.css'

// const Contact = () => {
//   return (
//     <div>Contact</div>
//   )
// }

// export default Contact